import angular from 'angular';

import UsersService from './UsersService';
import UsersComponent from './UsersComponent';

export default angular
  .module('petroCloud.admin.users', [])
  .service('UsersService', UsersService)
  .component(UsersComponent.name, UsersComponent)
  .name;
